<template>
  <div>
    <el-row>
      <span style="color: #aaaaaa">（0值表示不限，-1表示禁止）</span>
    </el-row>
    <el-table :data="list" style="width:100%" border>
            <el-table-column prop="title" width="200"></el-table-column>
            <el-table-column label="Web端实验示教限制（次）">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.teach_quota" @input="quotaInput()"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="Web端发布示教限制（次）">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.issue_quota" @input="quotaInput()"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="Web端发布考试限制（次）">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.exam_quota" @input="quotaInput()"></el-input>
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    list: {
      required: true,
      type: Array,
    },
    product_id: {
      required: true,
    },
    customer_id: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      formLabelWidth: "100px",
      rules: {
      },
    };
  },

  methods: {
    emit(){
      this.$emit('changeQuota', this.list);
    },

    /**
     * 修改额度
     * */
     quotaInput() {
      this.emit();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/order/vr/quotaLimit.vue